'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { createContext, useEffect, useMemo } from 'react';
import { useIdentity } from '../../hooks/useIdentity';
import type { IdentityResponse } from '../../lib/identity/identityService';
import { useStrictContext } from '../../lib/internal/hooks';
export type Identity = NonNullable<IdentityResponse['identity']>;
export type IdentityContextValue = {
  isLoading: boolean;
  identity?: Identity;
  identityId?: string;
  email?: string;
  isNWPlusMember: boolean;
  isLoggedIn: boolean;
  isRefetching: boolean;
  sheaId?: string;
};
export const IdentityContext = createContext<IdentityContextValue | null>(null);
export function useIdentityContext() {
  return useStrictContext(IdentityContext);
}
export function IdentityProvider(t0) {
  const $ = _c(15);
  const {
    children
  } = t0;
  const {
    loading,
    identity,
    identityId,
    isNWPlusMember,
    isLoggedIn,
    refetching,
    sheaId,
    email
  } = useIdentity();
  let t1;
  let t2;
  if ($[0] !== isLoggedIn) {
    t1 = () => {
      datadogRum.setUserProperty("is_logged_in", isLoggedIn ? "true" : "false");
    };
    t2 = [isLoggedIn];
    $[0] = isLoggedIn;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== email || $[4] !== identity || $[5] !== identityId || $[6] !== isLoggedIn || $[7] !== isNWPlusMember || $[8] !== loading || $[9] !== refetching || $[10] !== sheaId) {
    t3 = {
      isLoading: loading,
      isNWPlusMember,
      email,
      identity,
      identityId,
      isLoggedIn,
      isRefetching: refetching,
      sheaId
    };
    $[3] = email;
    $[4] = identity;
    $[5] = identityId;
    $[6] = isLoggedIn;
    $[7] = isNWPlusMember;
    $[8] = loading;
    $[9] = refetching;
    $[10] = sheaId;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const value = t3;
  let t4;
  if ($[12] !== children || $[13] !== value) {
    t4 = <IdentityContext.Provider value={value}>{children}</IdentityContext.Provider>;
    $[12] = children;
    $[13] = value;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}